import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HelpsupportComponent } from '@fitness-force/authentication';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'company-not-found',
  templateUrl: './company-not-found.component.html',
  styleUrls: ['./company-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    HelpsupportComponent,
    RouterModule
  ]
})
export class CompanyNotFoundComponent implements OnInit {

  domainUrl:string="";
  showSupportPopup:boolean=false;

  ngOnInit(): void {
    this.domainUrl = window.location.host;
  }

  closeSupportDialog(close: boolean) {
    this.showSupportPopup = false;
  }

}

